







































































































































































import { Component,  Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Form, {Send} from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import api, { AppExeptionsDialogsApi } from '../api';

import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import UiLogout from '@/components/ui/ui-logout.vue';
import CurrencyMixin from '@/components/helpers/currency-mixin';
import numeral from 'numeral';
import BillingApi from '@/services/rest/bemob/billing';
import config from '@/config';
import bus from '@/services/evbus';
import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';
import ModalHeader from '@/components/ui/ui-modal/modal/header.vue';
import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import IntercomMixin from '@/components/helpers/intercom-mixin';
import AdditionalInfo from './additional-info.vue';
import InvoicesTable from './invoices-table.vue';
import LoadingCircle from '@/components/loading-circle.vue';

type PaymentMethods = 'defaultCard' | 'newCard' | 'alipay' | 'wechat' | 'paypal';

  @Component({
    components: {
      FormOverlay,
      DialogForm,
      HeaderButtons,
      UiLogout,
      ModalHeader,
      ErrorAggregator,
      IntercomMixin,
      AdditionalInfo,
      InvoicesTable,
      LoadingCircle,
    }
  })
  export default class UnpaidInvoicesDialog extends mixins(Form, CurrencyMixin, PaymentStatusMixin, IntercomMixin) {
    last4NumbersOfExistedCard:string='';
    paymentMethod:PaymentMethods = 'newCard';
    loadingInvoices:Boolean = false;
    loadingStripe:Boolean = true;
    
    @Prop({default: false})
    visible: boolean;

    intervalCheckUnpaidInvoices: NodeJS.Timeout ;
    qrCodeLibraryLoaded: boolean = false;
    wechatCodeReady: boolean = false;
    showProcessing: boolean = false;
    disabled: boolean = false;
    invoicesList: Billing.invoicesList[];
    invoicesIds: string[] = [];

    errors: any[] = [];
    errorsControlActive: boolean = false;

    billingInfo={
      billing_address:{}
    }

    cardNumberElement: any = null;
    cardExpiryElement: any = null;
    cardCvcElement: any = null;
    stripe: any = null;
    cardElements: any = null;

    api: AppExeptionsDialogsApi = api;

    paymentIntent: Billing.PaymentIntent = {
      clientSecret:'',
      paymentMethodId:'',
      code:''
    };

    needToRecheckInvoices: boolean = false;

    billingApi: BillingApi = new BillingApi();
    subscriptionApi: SubscriptionApi = subscriptionApi;

    get payButtonText() {
      switch(this.paymentMethod) {
        case 'defaultCard':
          return this.requires3DS
            ? this.t('Confirm 3DS and pay ${0} With **** {1}',[this.totalUnpaidFormatted,this.last4NumbersOfExistedCard])
            : this.t('Pay ${0} With **** {1}',[this.totalUnpaidFormatted,this.last4NumbersOfExistedCard]);
        case 'newCard':
          return this.t('Pay ${0} With New Card',[this.totalUnpaidFormatted]);
        case 'wechat':
          return this.t('Pay ${0} With WeChat',[this.totalUnpaidFormatted]);
        case 'alipay':
          return this.t('Pay ${0} With AliPay',[this.totalUnpaidFormatted]);
      }
    };

    get contentClass() {
      let result = ['app-exceptions-resolver-dialog','unpaid-invoices-dialog'];

      if(this.internalPaymentGatewayEnabled) {
        result.push('unpaid-invoices-dialog--internal-enabled')
      }

      if(this.showProcessing) {
        result.push('unpaid-invoices-dialog--show-processing')
      }

      return result.join(' ');
    }

    get requires3DS() {
      const {clientSecret,paymentMethodId,code} = this.paymentIntent;
      return clientSecret && paymentMethodId && code==='authentication_required'
    }

    unpaidData: Billing.UnpaidData = {
      count: 0,
      invoices: [],
      totalUnpaid: 0
    };

    get totalUnpaid() {
      return this.sumFormat(this.unpaidData.totalUnpaid);
    }

    get totalUnpaidFormatted() {
      return this.sumFormat(this.unpaidData.totalUnpaid, '0.00')
    }

    async onStripeReady(){
      this.subscriptionApi.getCustomer().then(async (res: any) => {
          this.billingInfo = res.billingInfo
          this.last4NumbersOfExistedCard = res.paymentMethod?.card?.last4
          if(this.last4NumbersOfExistedCard){
          this.paymentMethod = 'defaultCard';
        }
      })

      if ((window as any).Stripe === undefined) {
        return this.bus.emit('toast-error', this.t('Stripe library isn\'t loaded'));
      }
      
      this.stripe = (window as any).Stripe(config.stripeToken, {
        locale: this.$i18n.locale
      });

      this.loadingInvoices = true
      await this.checkUnpaidInvoices();
      this.loadingInvoices = false
      
      this.unpaidData.invoices.forEach((invoice: Billing.UnpaidDataInvoice)=>{
        invoice.failures.forEach((failure: Billing.InvoiceFailure)=>{
          const {message,paymentIntent,gateway} = failure;
          if(message){
            this.bus.emit('toast-error', message ,{
              dontHide:true
            });
          }
          if(gateway==='stripe' && paymentIntent?.clientSecret && paymentIntent?.paymentMethodId){
            this.paymentIntent = paymentIntent
          }
        })
      })
      
      if(this.unpaidData.count) {
        this.invoicesList = this.unpaidData.invoices.map((item:Billing.UnpaidDataInvoice)=>{
          this.invoicesIds.push(item.id)
          return {
            reference_id:item.id,
            invoice_id:item.id,
            amount: {
              value: (item.amount_due/100).toFixed(2),
            }
          }
        });
      
        if(this.internalPaymentGatewayEnabled){
          this.initPayPal();
          // this.initWechat();
        }
      
        this.$on('error', (e: any, payload: any) => {
          this.$store.commit('loading', false);
          this.api.loading = false;
      
          this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
          this.errorsControlActive = true;
        });
      
        this.stripe = (window as any).Stripe(config.stripeToken, {
          locale: this.$i18n.locale
        });
        const style = {
          'base': {
            fontSize: '12px',
            color: this.$colors.graphite,
            lineHeight: '32px',
            fontFamily: 'Lato, Helvetica, sans-serif, -apple-system',
            letterSpacing:'0.6px',
          },
          invalid: {
            color: this.$colors.graphite,
            borderColor: this.$colors.red
          },
        }
        this.loadingStripe = false;
        this.$nextTick(()=> {
          this.cardElements = this.stripe.elements()
          this.cardNumberElement = this.cardElements.create('cardNumber', {style: style});
          this.cardNumberElement.mount(this.$refs.cardNumber);
          this.cardExpiryElement = this.cardElements.create('cardExpiry', {style: style});
          this.cardExpiryElement.mount(this.$refs.cardExpiry);
          this.cardCvcElement = this.cardElements.create('cardCvc', {style: style});
          this.cardCvcElement.mount(this.$refs.cardCvc);
        })
        this.$store.commit('loading', false);
      } else {
        await this.api.updateUser();
      }
    }
    
    async mounted() {
      if((window as any).Stripe){ 
        this.onStripeReady()
      }else{
        const stripeLibrary = document.createElement( 'script');
        stripeLibrary.src = 'https://js.stripe.com/v3/';
        document.head.appendChild(stripeLibrary);
        (stripeLibrary.onload as any) = this.onStripeReady
      } 
    }
  
    selectPaymentMethod(method:PaymentMethods) {
      this.paymentMethod = method
    }

    sumFormat(value: number, format = '0,0.00') {
      return numeral(value / 100).format(format);
    }
  
    get hasStatusPending() {
      return this.unpaidData.invoices
          .find((invoice)=>invoice.charges
          .find((charge)=>charge.status==='pending'));
    };

    async checkUnpaidInvoices(){
      this.unpaidData = await this.api.getUnpaidInvoices(); 

      if(this.unpaidData.invoices.length === 0) this.checkAndClose();
    }
  
    @Watch('hasStatusPending',{ immediate: true })
    handleStatusPending(value: number) {
      if(value){
        this.needToRecheckInvoices = true;
        this.showProcessing = true;
      }
    }


    @Watch('needToRecheckInvoices')
    handleRecheckInvoices(value: number) {
      if(value){
        this.intervalCheckUnpaidInvoices = setInterval(async ()=>{
          this.checkUnpaidInvoices()
        },5000);
      }
    }

    actionBeforeLogout(){
      clearInterval(this.intervalCheckUnpaidInvoices);
    }

    initWechat() {
      var qrCodeScriptFile = document.createElement( 'script' );
      qrCodeScriptFile.src = 'https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js';
      document.head.appendChild(qrCodeScriptFile);
      qrCodeScriptFile.onload = ()=> {
        this.qrCodeLibraryLoaded = true;
      }
    }

    initPayPal() {
      const renderButtons = ()=>{
        (window as any)?.paypal?.Buttons({
          style: {
            height: 32
          },
          createOrder: (data, actions)=> {
            return actions.order.create({
              purchase_units: this.invoicesList
            });
          },
          onClick: async ()=> {
            this.disabled = true;
            try{
              await this.validateBillingAddress()
            }catch (error){
              return false;
            }
          },
          onCancel:()=>{
            this.disabled = false;
          },
          onApprove: (data:any)=> {
            this.api.payPalCapture({
              orderID: data.orderID
            }).then(()=>{
              this.checkAndClose();
            })
          }
        }).render('#paypal-button-container');
      }

      
      if(!document.querySelector('script[src*="paypal.com/sdk/js"]')){
        var paypalScriptFile = document.createElement( 'script' );
        paypalScriptFile.src = `https://www.paypal.com/sdk/js?client-id=${config.payPalClientId}&disable-funding=card`;
        document.head.appendChild(paypalScriptFile);
        paypalScriptFile.onload = renderButtons;
        return;
      }

      if(!document.querySelector('#paypal-button-container').childNodes.length){
        renderButtons();
      }
    }

    async pay(){ 
      await this.validateBillingAddress()
    
      switch (this.paymentMethod){
        case 'defaultCard':
          return this.payNow();
        case 'newCard':
          return this.updateAndPay();
        case 'alipay':
          return this.payAliPay();
        case 'wechat':
          return this.payWechat();
      }
    }
      
    async payNow() {
      if(this.requires3DS){
        const confirm3DS = await this.stripe.confirmCardPayment(this.paymentIntent.clientSecret,{
          payment_method:this.paymentIntent.paymentMethodId,
        });
        if (confirm3DS.error) return bus.emit('toast-error',confirm3DS.error.message);
      }
      this.checkAndClose();
    }


    @Send()
    async updateAndPay() {
      this.disabled = true
      this.$store.commit('loading', true);
      const createPaymentMethod = await this.stripe.createPaymentMethod('card', this.cardNumberElement)

      if (createPaymentMethod.error){       
        this.disabled = false
        return this.submitErrorHandler(createPaymentMethod.error.message)
      }

      const setupIntent = await this.api.billingApi
        .setupIntent({
          paymentMethodId:createPaymentMethod.paymentMethod.id
        }).finally(()=> this.disabled = false)

      if(setupIntent.status==='requires_action' || setupIntent.status==='requires_source_action'){
        const confirmCardSetup = await this.stripe.confirmCardSetup(setupIntent.client_secret)
        if (confirmCardSetup.error) return this.submitErrorHandler(confirmCardSetup.error.message);
        return this.submitSuccess(confirmCardSetup.setupIntent.id)
      }

      if(setupIntent.status==='requires_payment_method' || setupIntent.status==='requires_source')
        return this.submitErrorHandler(this.t('Your card was denied, please provide a new payment method'));

      if(setupIntent.status==='succeeded') return this.submitSuccess(setupIntent.id)
     
    };


    submitErrorHandler(error:string){
      this.$store.commit('loading', false);
      this.state.loading = false;
      this.errors = [this.t('Validation failed'),error]
      this.errorsControlActive = true;
    }

    async submitSuccess(token:string){
      return await this.subscriptionApi.postUpdateCard({
        'token': token,
        'gateway': 'stripe3ds'
      }, true).then(() => {
        this.checkAndClose();
      })
    }

    async payAliPay() {
      this.disabled = true;
      const aliPayPaymentIntent = await this.billingApi.stripePaymentIntent({
        paymentMethodTypes: ['alipay'],
        amount: this.totalUnpaid,
        currency: 'USD',
        invoiceIds: this.invoicesIds
      }) as any;

      const {clientSecret} = aliPayPaymentIntent.data.payload;

      this.stripe.confirmAlipayPayment(
        clientSecret,
        {
          return_url: window.location.origin,
        }
      ).then((resp)=>{
        bus.emit('toast-error',resp.error.message);
      });
    }

    async payWechat() {
      this.disabled = true;
      const source = await this.billingApi.stripePaymentSource({
        type: 'wechat',
        amount: this.totalUnpaidFormatted,
        currency: 'usd',
        invoiceIds: this.invoicesIds
      }).then((res)=>res.data.payload) as Billing.StripePaymentSourceResponse;

      const qrCode = new (window as any).QRCode('wechat-qrcode', {
        text: source.wechat.qr_code_url,
        width: 128,
        height: 128,
        colorDark: this.$colors.graphite,
        colorLight: this.$colors.white,
        correctLevel: (window as any).QRCode.CorrectLevel.H,
      });
      this.wechatCodeReady = true;
      this.needToRecheckInvoices = true;
    }

    checkAndClose() {
      this.api.collectUnpaidInvoices().then(() => {
        (window as any).location.reload()
      })
    }

    @Send(true)
    validateBillingAddress(){
      return this.subscriptionApi.postUpdateBillingInfo(this.billingInfo)
    }
    
    get internalPaymentGatewayEnabled() {
      return this.$store.state.user.internalPaymentGatewayEnabled;
    }

  }
